"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeDeviceProperties = exports.computeNetworkType = exports.computeScreenSize = void 0;
exports.configureBrowserAttributesResource = configureBrowserAttributesResource;
const resources_1 = require("@opentelemetry/resources");
const ua_parser_js_1 = __importDefault(require("ua-parser-js"));
const computeScreenSize = (screenWidth) => {
    if (screenWidth <= 768)
        return 'small';
    else if (screenWidth > 768 && screenWidth <= 1024)
        return 'medium';
    else if (screenWidth > 1024)
        return 'large';
    return 'unknown';
};
exports.computeScreenSize = computeScreenSize;
const computeNetworkType = (networkInformation) => { var _a; return (_a = networkInformation === null || networkInformation === void 0 ? void 0 : networkInformation.effectiveType) !== null && _a !== void 0 ? _a : 'unknown'; };
exports.computeNetworkType = computeNetworkType;
const computeDeviceType = (detectedDeviceType, detectedBrowserName) => {
    // ua-parser-js doesn't fill in device type unless it's in the user agent directly
    // which means that desktops/laptops show up as undefined
    // https://github.com/faisalman/ua-parser-js/issues/182
    //
    // we're going to do this:
    // browser name & device type both undefined -> unknown
    // browser name defined & device type undefined -> desktop
    // device type defined -> use that
    if (!detectedDeviceType && !detectedBrowserName) {
        return 'unknown';
    }
    if (!detectedDeviceType) {
        return 'desktop';
    }
    return detectedDeviceType;
};
const computeDeviceProperties = (userAgent) => {
    const uaParser = new ua_parser_js_1.default(userAgent);
    const { name: browserName, version: browserVersion } = uaParser.getBrowser();
    return {
        browserName: browserName !== null && browserName !== void 0 ? browserName : 'unknown',
        browserVersion: browserVersion !== null && browserVersion !== void 0 ? browserVersion : 'unknown',
        deviceType: computeDeviceType(uaParser.getDevice().type, browserName),
    };
};
exports.computeDeviceProperties = computeDeviceProperties;
function configureBrowserAttributesResource() {
    const { browserName, browserVersion, deviceType } = (0, exports.computeDeviceProperties)(navigator.userAgent);
    return new resources_1.Resource({
        'user_agent.original': navigator.userAgent,
        //https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent#mobile_tablet_or_desktop
        'browser.mobile': navigator.userAgent.includes('Mobi'),
        'browser.touch_screen_enabled': navigator.maxTouchPoints > 0,
        'browser.language': navigator.language,
        'browser.name': browserName,
        'browser.version': browserVersion,
        'device.type': deviceType,
        'network.effectiveType': (0, exports.computeNetworkType)(navigator.connection),
        'screen.width': window.screen.width,
        'screen.height': window.screen.height,
        'screen.size': (0, exports.computeScreenSize)(window.screen.width),
    });
}
